import { queryOptions } from '@tanstack/react-query';
import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { TabelaPrecoSchema } from '../types/TabelaPreco';

export type TabelaPrecoConsultarParams = Partial<
    DefaultApiParams & {
        descricao: string;
    }
>;

const schema = registrosSchema(TabelaPrecoSchema);

function apiTabelaPrecoConsultar({
    idpk,
    params,
}: {
    idpk?: number;
    params?: TabelaPrecoConsultarParams;
}) {
    return fetchApi({
        endpoint: 'TabelaPreco/Consultar',
        idpk,
        method: 'get',
        params,
        schema,
    });
}

export const API_TABELA_PRECO_CONSULTAR_KEY = 'apiTabelaPrecoConsultar';

export function apiTabelaPrecoConsultarQueryOptions({
    idpk,
    params,
}: {
    idpk?: number;
    params?: TabelaPrecoConsultarParams;
}) {
    return queryOptions({
        queryFn: () => apiTabelaPrecoConsultar({ idpk, params }),
        queryKey: [API_TABELA_PRECO_CONSULTAR_KEY, { idpk, params }],
    });
}
